import type { EChartsOption } from 'echarts';
import type { BasicStatisticAge } from '../../services/graphApi';

const chartPalette = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#9a60b4', '#3ba272'];

// 대회가 생년월일을 수집하지 않으면 ageGroup이 없으므로, 연령 구분 없이 전체 합계 한 조각으로 보여준다.
export function toAgePieData(ages: BasicStatisticAge[]) {
  const counts = new Map<string, number>();

  ages.forEach((age) => {
    const label = age.ageGroup ?? '전체';
    counts.set(label, (counts.get(label) ?? 0) + age.participantCount);
  });

  return Array.from(counts.entries()).map(([name, value]) => ({ name, value }));
}

export function createAgePieOption(title: string, ages: BasicStatisticAge[]): EChartsOption {
  return {
    color: chartPalette,
    tooltip: {
      trigger: 'item',
      formatter: '{b}<br />{c}명 ({d}%)',
    },
    series: [
      {
        name: title,
        type: 'pie',
        radius: ['36%', '68%'],
        center: ['50%', '52%'],
        label: {
          formatter: '{b}\n{d}%',
          fontSize: 12,
          fontWeight: 700,
        },
        data: toAgePieData(ages),
      },
    ],
  };
}
